<app-tasks-table-mt
        [customColumns]="widgetData.content?.colons"
        [headerTransparent]="true"
        [onlyTable]="true"
        [rowsPerPages]="20"
        [tasksData]="widgetData.content?.data"
        [widgetView]="true"
></app-tasks-table-mt>
